// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"641":"a9ea985d","769":"4df78871","798":"61ca7f72","947":"5005e36f","962":"ea6eee88"}[chunkId] + ".css";
};